<template>
    <div
        @mouseenter="hover"
        @mouseleave="hover"
        @click="click"
        class="tooltip"
    >
        <i :class="icon"></i>

        <div
            v-show="show"
            class="tooltip-open"
        >
            {{ data }}
        </div>

        <div
            v-if="show"
            class="tooltip-overlay"
            @click="click"
        />
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: String,
            required: false
        },
        icon: {
            type: String,
            required: false,
            default: 'fas fa-info-circle'
        }
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        hover() {
            if (process.browser) {
                if (window.innerWidth > 1000) this.show =! this.show;
            }
        },

        click() {
            if (process.browser) {
                if (window.innerWidth < 1000) this.show =! this.show;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tooltip {
    position: relative;

    &-open {
        z-index: 2;
    }

    &-overlay {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;

        @media screen and (min-width: 1000px) {
            display: none;
        }
    }
}
</style>
